import { Body2 } from '@common/components/Typography';
import { CallToActionWrapper } from '@features/List/ListItem.styles';
import { token } from 'odyssey';
import { media } from 'styled-bootstrap-grid';
import styled from 'styled-components';

export const StyledProductBoxImage = styled.figure<{ isTransparent?: boolean }>`
  display: flex;
  margin: 0;
  opacity: ${({ isTransparent }) => (isTransparent ? 0.4 : 1)};

  img {
    width: 100%;
    height: 100%;
    ${media.md`
      max-height: 467px;
    `}
    object-fit: cover;
  }
  height: 150px;

  ${media.desktop`
    height: 254px;
  `}
`;

export const StyledImagePlaceholder = styled.div`
  height: 0;
  margin: 0;
  padding-top: 66.67%;
  background-color: ${({ theme }) => theme.tertiaryColour};
`;

export const StyledProductBoxOption = styled.div`
  font-size: 15px;
  line-height: 21px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

export const StyledProductBoxPrice = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 20px;
  width: 95%;
  padding-right: 12px;
  ${media.md`
    width: 97%;
    padding-right: 16px;
  `}
`;

export const MetadataRow = styled.p`
  font-size: 15px;
  line-height: 23px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  margin-top: 10px;
  min-height: 20px;
  padding-left: 16px;
`;

export const StyledProductTitle = styled.div`
  font-size: ${token('font-size-sm')};
  font-weight: ${token('font-weight-md')};
  color: ${token('color-text-dark')};
  margin: ${token('space-3')} 0;
`;
export const CallToActionTitleWrapper = styled(CallToActionWrapper)`
  margin-top: ${token('space-3')};
`;
export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  max-width: 100%;
`;

export const StyledPriceWrapper = styled.span`
  display: block;
  margin: 0;
  padding-left: 8px;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  font-size: 18px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;

export const StyledPrice = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 15px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

export const ProductInfo = styled.div`
  padding: 0 16px 52px;
`;

export const DurationInfo = styled(Body2)`
  display: block;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  margin-top: ${({ theme }) => theme.spaces.space4};
  margin-bottom: ${({ theme }) => theme.spaces.space1};
`;

export const ProductBoxStyled = styled.div`
  background: white;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
`;
